import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';

import NavBar from '@/components/nav-bar.vue';
import LoadingOverlay from '@/components/loading-overlay.vue';
import MessageCenter from '@/components/message-center.vue';
import { ProjectAction } from './models/project-action';

@Component({ components: { NavBar, LoadingOverlay, MessageCenter } })
export default class PlanningApp extends Vue {
  private action: ProjectAction = ProjectAction.None;

  private searchstring = '';

  private executeProjectAction(data: ProjectAction) {
    this.action = data;
  }

  private projectActionExecuted() {
    this.action = ProjectAction.None;
  }

  private passSearchstring(def: string) {
    this.searchstring = def;
  }
}
